import React, { useEffect } from 'react';
import { useDrag, DragPreviewImage } from 'react-dnd';
import { useSelector } from 'react-redux';
import { calculateDroppedEntitySize } from '../../utils/design.utils';
import PropTypes from 'prop-types';

const Draggable = props => {
  const designWidth = useSelector(state => state.design.width);
  const designHeight = useSelector(state => state.design.height);
  const canDrop = useSelector(state => state.graphicBuilder.canDrop);

  const [{ isDragging }, drag, preview] = useDrag({
    item: { type: props.type, data: props.data },
    /*end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult) {
        props.droped();
        alert(`You dropped ${item.name} into ${dropResult.name}!`);
      }
    },*/
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0.4 : 1;

  useEffect(() => {
    /*if (props.data) {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = props.data.srcThumbnail;
      const { width, height } = props.data;
      const { droppedWidth, droppedHeight } = calculateDroppedEntitySize(
        designWidth,
        designHeight,
        width,
        height,
      );
      const ctx = document.createElement('canvas').getContext('2d');
      ctx.canvas.width = droppedWidth;
      ctx.canvas.height = droppedHeight;

      img.onload = () => {
        ctx.drawImage(img, 0, 0, ctx.canvas.width, ctx.canvas.height);
        img.src = ctx.canvas.toDataURL();
        preview(img);
      };
    }*/
  }, []);

  return (
    <>
      <div
        ref={drag}
        className="draggable"
        onClick={() => props.onClick && props.onClick()}
        style={{ ...props.style, opacity }}
      >
        {props.children}
      </div>
    </>
  );
};

Draggable.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
  children: PropTypes.any,
  data: PropTypes.object,
  type: PropTypes.string,
};

export default Draggable;
